import { render, staticRenderFns } from "./SessionPosition.vue?vue&type=template&id=33fee007&scoped=true&"
import script from "./SessionPosition.vue?vue&type=script&lang=js&"
export * from "./SessionPosition.vue?vue&type=script&lang=js&"
import style0 from "./SessionPosition.vue?vue&type=style&index=0&id=33fee007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fee007",
  null
  
)

export default component.exports